export default __webpack_public_path__ + "static/avatar5-b06cfaad9543b9c1bc8553edc6204b2a.png";